
import { defineComponent } from "vue";

import { useRanking, usePilotList } from "@/hooks";
import { addPositionSufix, nameToURL } from "@/helpers";
import { Pilot, Ranking } from "@/interfaces";

import {TrophyIcon} from "@/components/UI/Icons";
import Avatar from "@/components/Pilots/Avatar.vue";

export default defineComponent({
  setup() {
    const pilots = usePilotList();
    const ranking = useRanking();

    function mixPilots(pilots: Pilot[], ranking: Ranking[]) {
      const res = [];

      for (const rank of ranking)
        for (const pilot of pilots)
          if (rank.pilotId === pilot._id)
            res.push({ pilot, points: rank.points, victories: rank.victories });

      return res;
    }

    const pilotRanking = mixPilots(pilots, ranking);
    return { pilotRanking, addPositionSufix, nameToURL };
  },
  name: "Leaderboard",
  components: {
    Avatar,
    TrophyIcon,
  },
});
